import React from 'react';

import { PageError } from '@/components/Error';
import { FormProps } from '@/components/Form';
import Loader from '@/components/Loader';
import useFile from '@/modules/tasks/views/TasksDashboard/hooks/useFile';

import Editor from './components/Editor';
import { TaskListEditorFormValues } from './components/Editor/config';

function SectionEditorContainer({
  setFormikSubmit,
  onSubmit,
  file,
  fetching,
  error,
}: {
  setFormikSubmit: FormProps<TaskListEditorFormValues>['setSubmitRef'];
  onSubmit: FormProps<TaskListEditorFormValues>['onSubmit'];
  file?: ReturnType<typeof useFile>['file'];
  fetching: boolean;
  error?: any;
}) {
  if (fetching) {
    return <Loader />;
  }

  if (error) {
    return <PageError error={error} />;
  }

  return <Editor file={file} setFormikSubmit={setFormikSubmit} onSubmit={onSubmit} />;
}

export default SectionEditorContainer;
